'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.backdoorLogin = exports.login = exports.loginWithCognito = exports.confirmPasswordResetWithCognito = exports.initiatePasswordResetWithCognito = exports.confirmSignup = exports.registerWithCognito = undefined;

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var registerWithCognito = exports.registerWithCognito = function registerWithCognito(username, password, email, firstName, lastName) {
  return function (dispatch, getState) {

    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/auth/cognito/register',
        method: 'POST',
        data: {
          username: username,
          password: password,
          email: email,
          firstName: firstName,
          lastName: lastName
        }
      },
      types: ['COGNITO_REGISTER_START', 'COGNITO_REGISTER', 'COGNITO_REGISTER_ERROR']
    }));
  };
};

var confirmSignup = exports.confirmSignup = function confirmSignup(username, confirmationCode) {
  return function (dispatch, getState) {

    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/auth/cognito/confirm',
        method: 'POST',
        data: {
          username: username,
          confirmationCode: confirmationCode
        }
      },
      types: ['COGNITO_CONFIRM_START', 'COGNITO_CONFIRM', 'COGNITO_CONFIRM_ERROR']
    }));
  };
};

var initiatePasswordResetWithCognito = exports.initiatePasswordResetWithCognito = function initiatePasswordResetWithCognito(username) {
  return function (dispatch, getState) {

    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/auth/cognito/password-reset/initiate',
        method: 'POST',
        data: {
          username: username
        }
      },
      types: ['COGNITO_INITIATE_PASSWORD_RESET_START', 'COGNITO_INITIATE_PASSWORD_RESET', 'COGNITO_INITIATE_PASSWORD_RESET_ERROR']
    }));
  };
};

var confirmPasswordResetWithCognito = exports.confirmPasswordResetWithCognito = function confirmPasswordResetWithCognito(username, confirmationCode, newPassword) {
  return function (dispatch, getState) {

    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/auth/cognito/password-reset/confirm',
        method: 'POST',
        data: {
          username: username,
          confirmationCode: confirmationCode,
          newPassword: newPassword
        }
      },
      types: ['COGNITO_CONFIRM_PASSWORD_RESET_START', 'COGNITO_CONFIRM_PASSWORD_RESET', 'COGNITO_CONFIRM_PASSWORD_RESET_ERROR']
    }));
  };
};

var loginWithCognito = exports.loginWithCognito = function loginWithCognito(provider, username, password) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/auth/validate',
        method: 'POST',
        data: {
          provider: provider,
          username: username,
          password: password

        }
      },
      types: ['COGNITO_LOGIN_START', 'COGNITO_LOGIN', 'COGNITO_LOGIN_ERROR']
    }));
  };
};

var login = exports.login = function login(provider, token) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/auth/validate',
        method: 'POST',
        data: {
          provider: provider,
          token: token
        }
      },
      types: ['APP_LOGIN_START', 'APP_LOGIN', 'APP_LOGIN_ERROR']
    }));
  };
};

var backdoorLogin = exports.backdoorLogin = function backdoorLogin(email) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/auth/backdoor/' + email
      },
      types: ['BACKDOOR_LOGIN_START', 'BACKDOOR_LOGIN', 'BACKDOOR_LOGIN_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/login/index.js
// module id = 654
// module chunks = 0